import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1796ef20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "master-crew-page" }
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-between items-center mb-6 gap-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-neutral-800" }, "Master Kru", -1))
const _hoisted_4 = { class: "flex items-center gap-3 w-full md:w-auto" }
const _hoisted_5 = { class: "relative w-full md:w-72 input-icon-right" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-4"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-blue-500" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times text-xs" }, null, -1))
const _hoisted_10 = { class: "flex justify-center items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "w-10 h-10 rounded-lg bg-neutral-200 flex items-center justify-center text-neutral-400"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-lg" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "font-semibold text-neutral-800" }
const _hoisted_16 = {
  key: 1,
  class: "badge-unavailable"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Belum Tersedia ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "mt-4 flex justify-center pb-2"
}

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import ProgressSpinner from 'primevue/progressspinner'
import Paginator from '@/views/components/paginator/Paginator.vue'
import EmptyState from '@/views/components/list/EmptyState.vue'
import FilterDropdown from '@/views/components/filter/FilterDropdown.vue'
import { useCrewPositions } from '@/composables/pages/master-setting/crew/useCrewPositions'
import { useCrewList } from '@/composables/pages/master-setting/crew/useCrewList'
import SsoUserPopover from './components/SsoUserPopover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter()
const store = useStore()
const {
  positionOptions,
  appliedPositionIds,
  activeFilters,
  isLoadingPositions,
  fetchPositions,
  handlePositionSearch,
  handleScrollEnd,
  removeFilter
} = useCrewPositions()

const {
  employees,
  totalRecords,
  pageNumber,
  pageSize,
  searchQuery,
  isLoading,
  fetchEmployees,
  handleSearch,
  onPageChange
} = useCrewList(appliedPositionIds)

const handleRemoveFilter = (pill: { value: string }) => {
  removeFilter(pill)
  fetchEmployees(true)
}
const handlePageChange = (event: { page: number; rows: number }) => {
  onPageChange(event)
}

const goToDetail = (id: string) => {
  router.push({
    name: 'master-crew-detail',
    params: { id }
  })
}

const onImageError = (e: Event) => {
  const target = e.target as HTMLImageElement
  if (target) {
    target.style.display = 'none'
  }
}

onMounted(() => {
  store.dispatch('ui/setBreadcrumbs', [])

  fetchPositions(true)
  fetchEmployees(true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(FilterDropdown, {
              label: "Jabatan",
              title: "Filter Jabatan",
              options: _unref(positionOptions),
              searchable: true,
              searchPlaceholder: "Cari jabatan...",
              loading: _unref(isLoadingPositions),
              modelValue: _unref(appliedPositionIds),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(appliedPositionIds) ? (appliedPositionIds).value = $event : null)),
              onApply: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchEmployees)(true))),
              onReset: _cache[2] || (_cache[2] = ($event: any) => (_unref(fetchEmployees)(true))),
              onScrollEnd: _unref(handleScrollEnd),
              onSearch: _unref(handlePositionSearch)
            }, null, 8, ["options", "loading", "modelValue", "onScrollEnd", "onSearch"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(InputText), {
                modelValue: _unref(searchQuery),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                placeholder: "Cari nama kru",
                class: "w-full input-default",
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_unref(handleSearch)(_unref(searchQuery)))),
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_unref(fetchEmployees)(true)), ["enter"]))
              }, null, 8, ["modelValue"]),
              _createElementVNode("i", {
                class: "pi pi-search text-neutral-400 cursor-pointer",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(fetchEmployees)(true)))
              })
            ])
          ])
        ]),
        (_unref(activeFilters).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeFilters), (pill) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pill.id,
                  class: "border border-blue-500 bg-blue-50 hover:bg-blue-100 rounded-full px-4 py-2 text-sm flex items-center gap-2 font-medium cursor-pointer transition-colors duration-150 text-blue-500",
                  onClick: ($event: any) => (handleRemoveFilter(pill))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(pill.label), 1),
                  _hoisted_9
                ], 8, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: _unref(employees),
          paginator: false,
          loading: _unref(isLoading),
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll"
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: "Tidak ada data ditemukan." })
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"50px","height":"50px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              header: "Foto",
              class: "w-16 text-center"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_10, [
                  (data.imageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: data.imageUrl,
                        alt: "Avatar",
                        class: "w-10 h-10 rounded-lg object-cover border border-neutral-200",
                        onError: onImageError
                      }, null, 40, _hoisted_11))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "fullName",
              header: "Nama Kru"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(data.fullName || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Jabatan" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data.latestEmployment?.positionName || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Email" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data.email || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "No. Telepon" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data.phoneNumber || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Username SSO" }, {
              body: _withCtx(({ data }) => [
                (data.authUserId)
                  ? (_openBlock(), _createBlock(SsoUserPopover, {
                      key: 0,
                      authUserId: data.authUserId,
                      phoneNumber: data.phoneNumber
                    }, null, 8, ["authUserId", "phoneNumber"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_19))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Aksi",
              class: "text-center",
              style: {"min-width":"130px","width":"130px"}
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_unref(Button), {
                  label: "Lihat Detail",
                  class: "btn-detail-action",
                  onClick: ($event: any) => (goToDetail(data.id))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"]),
        (_unref(totalRecords) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(Paginator, {
                first: (_unref(pageNumber) - 1) * _unref(pageSize),
                rows: _unref(pageSize),
                totalRecords: _unref(totalRecords),
                rowsPerPageOptions: [10, 20, 50],
                onOnPage: handlePageChange
              }, null, 8, ["first", "rows", "totalRecords"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})